export default "__VITE_ASSET__9b731c00__"